import { render, staticRenderFns } from "./downloadbill.vue?vue&type=template&id=228f1d89&"
import script from "./downloadbill.vue?vue&type=script&lang=js&"
export * from "./downloadbill.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports